module.exports = __webpack_public_path__ + "static/media/dew.fd3fdc14.svg";